import React from 'react';
import { motion } from 'framer-motion';
import Seo from '../components/Seo';
import { seo } from '../seo/seoData';

const ConfidentialitePage = () => {
  return (
    <div className="min-h-screen bg-black pt-20" data-testid="confidentialite-page">
          <Seo {...seo.confidentialite} />
      <section className="py-24 md:py-32">
        <div className="max-w-[800px] mx-auto px-6 md:px-12">
          <motion.div
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
          >
            <h1 className="font-heading text-4xl md:text-5xl font-bold text-white tracking-tight mb-12">
              Politique de confidentialité
            </h1>

            <div className="prose prose-invert max-w-none space-y-8">
              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Collecte des données</h2>
                <p className="text-neutral-400">
                  Dans le cadre de nos services VTC, nous collectons les données personnelles suivantes :
                </p>
                <ul className="text-neutral-400 list-disc list-inside mt-2 space-y-1">
                  <li>Nom et prénom</li>
                  <li>Adresse email</li>
                  <li>Numéro de téléphone</li>
                  <li>Adresses de prise en charge et de destination</li>
                  <li>Date et heure de la course</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Utilisation des données</h2>
                <p className="text-neutral-400">
                  Vos données personnelles sont utilisées exclusivement pour :
                </p>
                <ul className="text-neutral-400 list-disc list-inside mt-2 space-y-1">
                  <li>Traiter et confirmer vos réservations</li>
                  <li>Vous contacter concernant votre course</li>
                  <li>Générer les factures</li>
                  <li>Améliorer nos services</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Protection des données</h2>
                <p className="text-neutral-400">
                  Conformément au Règlement Général sur la Protection des Données (RGPD), 
                  nous mettons en œuvre toutes les mesures techniques et organisationnelles 
                  appropriées pour protéger vos données personnelles contre tout accès, 
                  modification, divulgation ou destruction non autorisés.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Conservation des données</h2>
                <p className="text-neutral-400">
                  Vos données personnelles sont conservées pendant la durée nécessaire 
                  à la réalisation des finalités pour lesquelles elles ont été collectées, 
                  et conformément aux obligations légales de conservation.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Vos droits</h2>
                <p className="text-neutral-400">
                  Conformément à la réglementation en vigueur, vous disposez des droits suivants :
                </p>
                <ul className="text-neutral-400 list-disc list-inside mt-2 space-y-1">
                  <li>Droit d'accès à vos données</li>
                  <li>Droit de rectification</li>
                  <li>Droit à l'effacement</li>
                  <li>Droit à la limitation du traitement</li>
                  <li>Droit à la portabilité</li>
                  <li>Droit d'opposition</li>
                </ul>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Cookies</h2>
                <p className="text-neutral-400">
                  Ce site utilise des cookies techniques nécessaires à son bon fonctionnement.
                  Ces cookies ne collectent pas de données personnelles à des fins de marketing.
                </p>
              </section>

              <section>
                <h2 className="font-heading text-2xl font-semibold text-white mb-4">Contact</h2>
                <p className="text-neutral-400">
                  Pour exercer vos droits ou pour toute question concernant notre politique 
                  de confidentialité, contactez-nous :<br />
                  Téléphone : 09 39 24 23 20<br />
                  WhatsApp : 07 66 30 15 03
                </p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  );
};

export default ConfidentialitePage;
